<ion-header class="ion-no-border">

    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="close()">
                <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>Pending orders</ion-title>
    </ion-toolbar>

</ion-header>

<ion-content>

    <ion-list>
        <ion-item *ngIf="pending_orders && pending_orders.length" lines="full">
            <ion-label>Total</ion-label>
            {{pending_orders.length}} 
        </ion-item>
    </ion-list>

</ion-content>

<ion-footer class="ion-no-border">
    
    <ion-list>
        <ion-item button="true" lines="none" detail="false" color="success" class="ion-text-center" (click)="copyToClipboard()">
            <ion-label>COPY PENDING ORDER DATA</ion-label>
        </ion-item>
    </ion-list>

</ion-footer>